export const resource = [
    {
        title:"LEARN —",
        desc1:"MailChimp 101",
        desc2:"Guides and Tutorials",
        desc3:"Case Studies"
    },
    {
        title:"COMMUNITY —",
        desc1:"For Freelancers",
        desc2:"For Developers",
        desc3:"Hire A Trusted Partner"
    }
]